export default __webpack_public_path__ + "static/media/tour-booking.234ddf22.png";